import {LocalGithubUser } from "types"
export const defaultUser: LocalGithubUser = { 
    
        "login": "Scoteezy",
        "avatar": "https://avatars.githubusercontent.com/u/59018563?v=4",
        "name": "Denis Bondarenko",
        "company": '',
        "blog": "https://vk.com/devdvlive",
        "location": "Russia",
        "bio": "junior front-end developer\r\ntg: devdvlive\r\nmail: scoteeezy@gmail.com",
        "twitter" : '',
        "repos": 19,
        "followers": 2,
        "following": 4,
        "created": "2019-12-18T12:41:21Z",
}